<div [hidden]="!labelOff" class="label label-off" (click)="valueChanged(false)">{{ labelOff }}</div>

<div class="toggle-wrapper {{value ? 'on' : 'off'}}" (click)="valueChanged(!value)" [ngClass]="standAlone ? 'stand-alone' : ''">
	<span class="toggle" #toggle></span>
	<span class="placeholder"></span>
	<span class="placeholder"></span>
</div>

<div [hidden]="!labelOn" class="label label-on" (click)="valueChanged(true)">{{ labelOn }}</div>
